module.exports = __webpack_public_path__ + "img/1466168264.93061e78.jpg";